/**
 * @file The lists module.
 * @author Tom Verschoore de la Houssaije
 */
import { AgendaGridComponent } from './agenda-grid/agenda-grid.component';
import { PlanboardGridComponent } from './planboard-grid/planboard-grid.component';
import { GridViewComponent } from './grid-view/grid-view.component';
import { AgendaListComponent } from './agenda-list/agenda-list.component';
import { ComponentRegistry } from '../core/component-registry';
import { AdHocComponent } from './ad-hoc/ad-hoc.component';
/**
 * The module of the lists block.
 */
var GridsModule = /** @class */ (function () {
    /**
     * Constructs a ListModule.
     */
    function GridsModule() {
        ComponentRegistry.register('grid', 'PlanboardGridComponent', PlanboardGridComponent);
        ComponentRegistry.register('grid', 'AgendaGridComponent', AgendaGridComponent);
        ComponentRegistry.register('list', 'AgendaListComponent', AgendaListComponent);
        ComponentRegistry.register('overlay', 'AdHocComponent', AdHocComponent);
        ComponentRegistry.register('route', 'GridViewComponent', GridViewComponent);
    }
    return GridsModule;
}());
export { GridsModule };
